import { createSelector } from 'reselect'

export const getTempLogo = createSelector(
  state => state && state.user && state.user.registration && state.user.registration.tempLogo
    ? state.user.registration.tempLogo : null,
  tempLogo => tempLogo
)
